import React, { FunctionComponent } from 'react';
import Illustration from './illustration.svg';

export type HeroTitleProps = {
    text: string;
};

const HeroTitle: FunctionComponent<HeroTitleProps> = ({ text }) => {
    return (
        <div className="hero-title">
            <Illustration />
            <h1 className="hero-title__text">{text}</h1>
        </div>
    );
};

export default HeroTitle;
